export default __webpack_public_path__ + "static/media/gallery_01.7f43c4ef.jpg";